import type { ComputedRef, InjectionKey, Ref } from 'vue';

export const SECTION_TABLE_SEARCH_QUERY_KEY: InjectionKey<ComputedRef<string> | Ref<string>> =
  Symbol('sectionTableSearchQuery');

export const SECTION_TABLE_NOTIFY_COPIED_KEY: InjectionKey<() => void> = Symbol('sectionTableNotifyCopied');
